import { dataMember, required } from 'santee-dcts';
import { deserializers } from '../core';
import * as moment from 'moment';
import { Age } from '../subjects/age';
import { siteDisplayNameRenderer } from '../renderer/site-display-name-renderer';

export class SponsorSubject {

    @dataMember()
    @required()
    public siteId: number;

    @required({ nullable: true })
    @dataMember()
    public siteNumber: string;

    @required({ nullable: true })
    @dataMember()
    public subjectNumber: string;

    @required()
    @dataMember()
    public subjectId: number;

    @required({ nullable: true })
    @dataMember()
    public zcSubjectId: string;

    @dataMember()
    @required({ nullable: true })
    public subjectInitials: string;

    @required()
    @dataMember()
    public alertsCount: number;

    @required({ nullable: true })
    @dataMember()
    public gender: string;

    @required({ nullable: true })
    @dataMember()
    public investigatorFullName: string;

    @dataMember({ customDeserializer: deserializers.deserializeDate })
    @required({ nullable: true })
    public lastVisitDate: moment.Moment;

    @required({ nullable: true })
    @dataMember()
    public lastVisitDescription: string;

    public get siteDisplayName(): string {
        return siteDisplayNameRenderer({ siteNumber: this.siteNumber, investigatorFullName: this.investigatorFullName});
    }

    @dataMember()
    @required({ nullable: true })
    public age: Age;

    @dataMember()
    @required({ nullable: true })
    public screeningNumber: string;

    @dataMember()
    @required({ nullable: true })
    public ageProjectDisplayValue: string;

    @dataMember()
    @required({ nullable: true })
    public isAgeProject: boolean;

 }
